import { render, staticRenderFns } from "./RegistrationsClear.vue?vue&type=template&id=2799adce&scoped=true"
import script from "./RegistrationsClear.vue?vue&type=script&lang=js"
export * from "./RegistrationsClear.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsClear.vue?vue&type=style&index=0&id=2799adce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799adce",
  null
  
)

export default component.exports